<template>
  <global-window title="修改密码" :visible.sync="dialogVisible" :show="true" width="20%" @confirm="confirmModify">
    <el-form label-width="100px">
      <el-form-item label="平台">
        <!-- <el-select v-model="formData.platform_id" placeholder="请选择" filterable>
          <el-option
            v-for="item in platformSelectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select> -->
        <el-input v-model.trim="formData.name" disabled />
      </el-form-item>
      <el-form-item label="账号">
        <el-input v-model.trim="formData.account" disabled />
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model.trim="formData.pwd" show-password />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model.number="formData.remark" />
      </el-form-item>
    </el-form>
  </global-window>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
export default {
  name: 'ModifyAccountDialog',
  components: {
    GlobalWindow
  },
  data() {
    return {
      dialogVisible: false,
      id: null,
      formData: {
        name: null,
        pwd: null,
        account: null,
        remark: null
      }
    }
  },
  methods: {
    open(e) {
      this.id = e.id
      this.formData.name = e.platform.name
      this.formData.pwd = e.pwd
      this.formData.account = e.account
      this.formData.remark = e.remark
      this.dialogVisible = true
    },
    confirmModify() {
      if (this.formData.pwd === '' || this.formData.pwd === null || this.formData.pwd === undefined) {
        this.$message({
          message: '密码不能为空',
          type: 'error'
        })
        return
      }
      if (this.formData.pwd.length < 6) {
        this.$message({
          message: '密码长度必须在6位数以上',
          type: 'error'
        })
        return
      }
      if (this.formData.remark === null || this.formData.remark === undefined) {
        this.$message({
          message: '备注不能为空',
          type: 'error'
        })
        return
      }
      this.$emit('emitModifyAccount', this.id, this.formData.pwd, this.formData.remark)
      this.dialogVisible = false
    }
  }
}
</script>

<style>

</style>
